export const getObjectFromArray = (arr: any[]) => {
  if (!arr) {
    return {};
  }

  return arr.reduce((acc, next) => {
    return {
      ...acc,
      [next]: next,
    };
  }, {});
}